<section class="content-page">
  <div>
    <div class="title3">
      <h2 class="fs-sm-7 fs-md-5 fw-semibold">Nuestro equipo</h2>
      <span class="fw-semibold fs-sm-7 fs-md-4">El equipo de Kaizen Wealth Planning comparte pasión por la excelencia, empatía
        genuina y más de 50 años de experiencia combinada.</span>
    </div>
  </div>
  <div class="equipo d-md-flex d-none">
    <div *ngFor="let persona of personas" class="persona-card">
      <div class="imagen-contenedor">
        <img [src]="persona.imagen" alt="{{ persona.nombre }}" class="imagen">
      </div>
      <div class="texto-contenedor">
        <span class="nombre fw-bold">{{ persona.nombre }}</span>
        <button class="btn-proyecto">
          <span class="cargo">{{ persona.cargo }}</span>
          <span> | </span>
          <img [src]="persona.linkedin" class="linkedin-link">
        </button>
      </div>
    </div>
  </div>
</section>
